import { Component, OnInit, Inject } from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { PeticionesHttpBackEndService } from '../../@core/mock/peticiones-http-backend.service';
import { NbAuthJWTToken, NbAuthService } from '@nebular/auth';
import { UtilidadesService } from '../../@core/utils/utilidades.service';
import { Router, NavigationExtras } from '@angular/router';
import { DatePipe } from '@angular/common';
import { AngularEditorConfig } from '@kolkov/angular-editor';

@Component({
  selector: 'nb-dialog-template',
  templateUrl: './modal-add-actividad.component.html',
  styleUrls: ['./modal-add-actividad.component.scss'],
  providers: [PeticionesHttpBackEndService, UtilidadesService]
})

export class ModalAddActividadComponent implements OnInit {
  private valorSelect: number;
  constructor(private router:Router, public utilidades: UtilidadesService, public dialogRef: MatDialogRef<ModalAddActividadComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: any, public _PeticionesHttpBackEndService: PeticionesHttpBackEndService, private authService: NbAuthService,datepipe: DatePipe) { 
      this.nuevaActividad = {_titulo:"",_tipologia_actividad_id:""}
      this.datepip = datepipe;
      this.modelCrearMuro = false;
  }
  datepip:any;
  TipologiasSelect: any;
  tokenRequest: any;
  nuevaActividad: any;
  resultSource:any;
  fechaInicio = new Date();
  fechaFin = new Date();
  fechaInscripcion = new Date();
  titulo:any ="";
  tipo:any;
  precioSocios:any = 0;
  precioNoSocios:any = 0;
  aforo:any = 0;
  duracion:any = 0;
  edicion:any = 0;
  descripcion:any = "";
  fileData: File = null;
  ArchivoSeleccionado: any;
  imagenRuta:any;
  checkSoloSocios:boolean=false;
  modelSocios:boolean = false;
  modelDesactivar:boolean = false;
  modelCrearMuro:boolean;
  public options: Object = {
    placeholderText: 'Descripción de la actividad...',
    charCounterCount: true
  }

  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    placeholder: 'Descripción de la actividad...',
    translate: 'no',
    sanitize: false,
    toolbarPosition: 'top',
    defaultFontName: 'Arial',
    height: '15rem',
    minHeight: '5rem',
  };

  ngOnInit() {
    this.authService.getToken()
    .subscribe((token: NbAuthJWTToken) => {
      if (token.isValid()) {

        this.tokenRequest = token;
    
        this._PeticionesHttpBackEndService.getAllTipologias("v1/tipologias").subscribe( 
          result => {
            this.resultSource = result;
            this.TipologiasSelect = this.resultSource.Tipologia;
          },
          error => {
          }
        );
      }
    }); 
  }


  setObjetoNuevaActividad(event){
    let elemento = event.target.tagName;
    let tipo = event.target.type;
    if (elemento == "INPUT" && tipo == "text"){
      switch(event.target.name){
        case "_titulo": this.nuevaActividad._titulo = event.target.value; break;
      }
    }
    if (elemento == "SELECT" && tipo == "select-one"){
      switch(event.target.name){
        case "_tipologia_actividad_id": this.nuevaActividad._tipologia_actividad_id = event.target.value; break;
      }
    }
  }

  selectRedSocial(event){
  }

  save(){
      if(this.titulo == '' || this.titulo == undefined 
      || this.tipo == '' || this.tipo == undefined 
      || this.fechaInicio == undefined 
      || this.fechaFin == undefined 
      || this.precioSocios == undefined 
      || ((this.precioNoSocios == undefined) && !this.modelSocios)
      || this.aforo == '' || this.aforo == undefined
      || this.duracion == '' || this.duracion == undefined
      || this.edicion == '' || this.edicion == undefined
      || this.fechaInscripcion == undefined
      || this.descripcion == '' || this.descripcion == undefined
      || this.imagenRuta == '' || this.imagenRuta == undefined){
        this.utilidades.notificationWarning("Info",""+"Debe rellenar los campos"+"","top-left");
      }else{
        this._PeticionesHttpBackEndService.insertaObjecto("v1/nuevaActividad",{Data: {"Titulo":this.titulo,"TipologiaId":this.tipo,"FechaInicio":this.datepip.transform(this.fechaInicio, "yyyy-MM-dd"),
        "FechaFin":this.datepip.transform(this.fechaFin, "yyyy-MM-dd"),"PrecioSocios":this.precioSocios,"PrecioNoSocios":this.precioNoSocios,"Aforo":this.aforo,
        "Duracion":this.duracion,"Edicion":this.edicion,"FechaInscripcion":this.datepip.transform(this.fechaInscripcion, "yyyy-MM-dd"),"Descripcion":this.descripcion,"Imagen":this.imagenRuta,"SoloSocios":this.checkSoloSocios,"Desactivar":this.checkDesactivar,"CrearMuro":this.modelCrearMuro}}).subscribe(
          result => {
            let resultado;
            resultado = result;
            if (resultado.Code == 500){
              this.utilidades.notificationWarning("Error",""+resultado.message+"","top-left");
            }else{
             /*Subida de imagen*/
                const formData = new FormData();
                formData.append('file', this.fileData);

                this._PeticionesHttpBackEndService.uploadFileActividades(formData,resultado.ActividadId, false)

                  .subscribe(res => {
                    resultado = res;
                    if (resultado.Code == 200){
                      this.imagenRuta = resultado.Archivo.original_name;
                     // this.utilidades.notificationSuccess("Correcto","El archivo ha sido subido correctamente","top-left");
                     this.utilidades.notificationSuccess("Éxito","Actividad creada con éxito","top-left");
                     this.dialogRef.close();
                    }else{
                      this.ArchivoSeleccionado = "";
                      this.utilidades.notificationWarning("Aviso",resultado.Mensaje,"top-left");
                    }
                  })
              /**/
              
            }
          },
          error => {
          }
        );
      }
      
   // }
    
  }

  close(){
    this.dialogRef.close();
  }
  handleFileInput(event){
    this.fileData = event.target.files[0];
    }
  onSubmit() {
   // let resultado;
    const formData = new FormData();
    formData.append('file', this.fileData);
    this.utilidades.notificationSuccess("Correcto","El archivo ha sido cargado correctamente","top-left");
    this.imagenRuta ="true";
    /*this._PeticionesHttpBackEndService.uploadFile(formData)
      .subscribe(res => {
        resultado = res;
        if (resultado.Code == 200){
          this.imagenRuta = resultado.Archivo.original_name;
          this.utilidades.notificationSuccess("Correcto","El archivo ha sido subido correctamente","top-left");
        }else{
          this.ArchivoSeleccionado = "";
          this.utilidades.notificationWarning("Aviso",resultado.Mensaje,"top-left");
        }
        
      })*/
  }

  soloSocios(checked: any) {
    this.precioNoSocios = "0";
    this.checkSoloSocios = this.modelSocios;
  }
  checkDesactivar:boolean = false;
  changeDesactivar(checked: any) {
    this.checkDesactivar = this.modelDesactivar;
  }

}
